export default "__VITE_ASSET__Ci4X1nb7__"